export type FilterItem = {
  slug: string;
  label: string;
  value: string;
};

export type FilterOption = {
  label: string;
  value: string;
  slug?: string;
  isCareSelection?: boolean;
  disabled?: boolean;
};

export type FilterOptionRange = {
  from: number;
  to: number;
  fromLabel: string;
  toLabel: string;
};

type FilterRange = {
  type: 'range';
  slug: string;
  label?: string;
  options: FilterOptionRange;
};

type FilterCheckbox = {
  type: 'checkbox';
  slug: string;
  label?: string;
  options: FilterOption[];
};

type FilterToggleList = {
  type: 'toggleList';
  slug: string;
  label?: string;
  options: FilterOption[];
};

export type FilterLabelList = {
  type: 'labelList';
  slug: string;
  label?: string;
  options: FilterOption[];
};

export type Filter = (
  | FilterRange
  | FilterCheckbox
  | FilterToggleList
  | FilterLabelList
) & { isCareSelection?: boolean; position?: number; disabled?: boolean };

export type FilterTypes = Filter['type'];

export type Filters = {
  mainFilters: Filter[];
};

export type SelectedFilters = {
  [key: string]: FilterOption['value'][] | [number, number];
};

export const FilterKeys = {
  sortBy: 'sortBy',
  mainFilters: 'mainFilters',
  filters: 'filters'
} as const;

export type FilterKeys = (typeof FilterKeys)[keyof typeof FilterKeys];

export type FilterChangeArgs = {
  key: FilterKeys;
  slug: string;
  value: FilterOption['value'] | FilterOption['value'][] | [number, number];
  checked?: boolean;
};

export type TopCategories = {
  name?: string | null;
  path?: string | null;
  url_key?: string | null;
  include_in_menu?: number | null;
  uid?: string | null;
  is_active: number;
};
